import { syncEmailInvitesForCurator as syncEmailInvitesApi } from '../services/campaignSubmissionService';

export const syncEmailInvitesForCurator = async (userProfileObjectId: string): Promise<void> => {
  try {
    let userInfo: Record<string, unknown> = {};
    let spotifyUser: Record<string, unknown> = {};
    try {
      userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    } catch {
      return;
    }

    const normalizedEmail = userInfo?.email?.toString?.().trim?.().toLowerCase?.();
    const userId = typeof userInfo?.userId === 'string' ? userInfo.userId : '';

    if (!userProfileObjectId || !normalizedEmail || spotifyUser?.isShared === true) {
      return;
    }

    await syncEmailInvitesApi({
      curatorProfileId: userProfileObjectId,
      email: normalizedEmail,
      emailVerified: userInfo?.emailVerified === true,
      userId,
    });
  } catch (error) {
    console.error('Failed to sync email invites for curator:', error);
  }
};
